import { QueryHookOptions, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { useShowErrorsPopup } from '@/hooks'
import { fragments } from '@/hooks/fragments'
import {
  ECountry,
  Query,
  QueryGetStorageFacilityArgs,
  ShopOpts,
  StorageFacility,
} from '@/schemaTypes'

const GET_STORAGE_FACILITY = gql`
  query getStorageFacility($storageFacilityId: ObjectId!, $shopOpts: ShopOpts) {
    getStorageFacility(storageFacilityId: $storageFacilityId) {
      _id
      name
      external
      shopIds
      shops(opts: $shopOpts) {
        _id
        name
      }
      storageUnitIds
      address {
        ...AddressFragment
      }
    }
  }
  ${fragments.address}
`

type TData = { getStorageFacility: Query['getStorageFacility'] }
type TVariables = QueryGetStorageFacilityArgs & { shopOpts?: ShopOpts }

const defaultStorageFacility: StorageFacility = {
  _id: '',
  name: '',
  external: false,
  address: {
    coordinates: {
      lat: 0,
      lng: 0,
    },
    houseNumber: '',
    stairway: '',
    door: '',
    floor: '',
    street: '',
    city: '',
    state: '',
    countryCode: ECountry.At,
    country: '',
    zipCode: '',
    queryString: '',
    address1: '',
    address2: '',
    note: '',
  },
  shopIds: [],
  shops: [],
  storageUnitIds: [],
  storageUnits: [],
}

export function useGetStorageFacility(
  opts: QueryHookOptions<TData, TVariables> = {},
) {
  const queryResult = useQuery<TData, TVariables>(GET_STORAGE_FACILITY, {
    fetchPolicy: 'network-only',
    ...opts,
    skip: !opts.variables?.storageFacilityId,
  })

  useShowErrorsPopup(queryResult.error)

  const storageFacility = opts.variables?.storageFacilityId
    ? queryResult.data?.getStorageFacility
    : defaultStorageFacility
  return { queryResult, storageFacility }
}
